import { ui } from "@/components/ui";
import {
	diaryByIdQueryOptions,
	useDiaryByIdQuery,
} from "@/features/diaries/api";
import DiaryTitle from "@/features/patients/features/interface/components/DiaryTitle";
import InterfaceButtons from "@/features/patients/features/interface/components/InterfaceButtons";
import { useProfileByIdQuery } from "@/features/profile/api/selectProfile";
import {
	DateOfBirthDialog,
	EmailDialog,
	NameDialog,
	PhoneDialog,
} from "@/features/profile/components/EditProfileDialogs";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import EditDialog from "../../../../components/common/EditDialog";
import SharedAttributeHospitalNumberForm from "../../../../features/shared_attributes/components/SharedAttributeHospitalNumberForm";

const EditDiaryPatientsPage = () => {
	const { diaryId } = Route.useParams();
	const { data: diary } = useDiaryByIdQuery(diaryId);
	const { data: profile } = useProfileByIdQuery(diary?.patient_id ?? "");

	if (!diary || !profile) {
		return null;
	}

	return (
		<section className="flex flex-col h-full">
			<InterfaceButtons diaryId={diaryId} />
			<div className="flex flex-col gap-2 mt-3 px-1 pb-8 h-full overflow-y-scroll">
				<Suspense fallback={<ui.Skeleton className="w-48 h-10" />}>
					<DiaryTitle
						patientName={profile.name}
						isEditing={true}
						diaryId={diaryId}
					/>
				</Suspense>
				{/* <PatientCard profile={profile} editable={true} /> */}
				<Suspense fallback={<ui.Skeleton className="w-full h-60" />}>
					<ui.Card className="">
						<ui.CardHeader>
							<ui.CardTitle className="text-xl">Patient Details</ui.CardTitle>
						</ui.CardHeader>
						<ui.CardContent className="">
							<NameDialog editable={true} profile={profile} />
							<DateOfBirthDialog editable={true} profile={profile} />
							<EmailDialog editable={true} profile={profile} locked={true} />
							<PhoneDialog editable={true} profile={profile} locked={true} />
							<EditDialog
								label="Hospital Number"
								info={diary.shared_attributes?.hospital_number}
							>
								<SharedAttributeHospitalNumberForm
									sharedAttributes={diary.shared_attributes}
								/>
							</EditDialog>
							{/* <NhsNumberDialog profile={profile} /> */}
						</ui.CardContent>
					</ui.Card>
				</Suspense>
			</div>
		</section>
	);
};

export const Route = createFileRoute("/_app/patients/$diaryId/edit")({
	component: EditDiaryPatientsPage,
});
